import { colors, spacing } from '../../../themes/variables';
import { FelaCSS, FelaCSSWithCustomSelectors } from '../../fela/flowtypes';

interface IStyles {
  wrapper: FelaCSSWithCustomSelectors;
  innerWrapper: FelaCSS;
  input: FelaCSS | FelaCSSWithCustomSelectors;
  label: FelaCSS;
  error: FelaCSS;
  charCounter: FelaCSS;
}

const styles = ({
  hasError,
  disabled,
  variant = 'default',
}: {
  hasError: boolean;
  disabled: boolean;
  variant?: 'default' | 'borderless';
}): IStyles => ({
  wrapper: {
    border:
      variant === 'borderless'
        ? 'none'
        : hasError
          ? `1px solid ${colors.alerts}`
          : `1px solid ${colors.space40}`,
    borderRadius: 16,
    ...(!disabled &&
      !hasError &&
      variant !== 'borderless' && {
        ':focus-within': { border: `1px solid ${colors.indigoCrush}` },
        ':hover': { border: `1px solid ${colors.space}` },
        ':focus': { border: `1px solid ${colors.indigoCrush}` },
      }),
    justifyContent: 'space-between',
    flexDirection: variant === 'borderless' ? 'column' : 'row',
    alignItems: variant === 'borderless' ? 'stretch' : 'flex-start',
    width: '100%',
    backgroundColor:
      variant === 'borderless' ? 'transparent' : disabled ? colors.space04 : colors.white,
    position: 'relative',
    ...(variant === 'borderless' && {
      paddingBottom: 2,
      ':after': {
        content: '""',
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        height: 1,
        backgroundColor: hasError ? colors.alerts : disabled ? colors.space04 : colors.space15,
      },
      ':hover:after': !disabled && {
        backgroundColor: hasError ? colors.alerts : colors.space,
      },
      ':focus-within:after': !disabled && {
        backgroundColor: hasError ? colors.alerts : colors.indigoCrush,
      },
    }),
  },

  innerWrapper: {
    width: '100%',
    minHeight: 120,
    ...(variant === 'borderless'
      ? {
          padding: `${spacing[1]} 0`,
        }
      : {
          padding: `${spacing[2]} ${spacing[4]}`,
          border: 'none',
          borderRadius: 16,
        }),
  },

  input: {
    border: 'none',
    fontSize: 16,
    fontWeight: 400,
    width: '100%',
    minHeight: '100%',
    resize: 'none',
    outline: 'none',
    backgroundColor: 'transparent',
    color: disabled ? colors.space40 : colors.space,
    padding: 0,
    '::placeholder': {
      color: colors.space40,
    },
  },

  label: {
    fontDefaultSemiBold: 12,
    ...(variant === 'borderless'
      ? {
          paddingLeft: 0,
          color: hasError ? colors.alerts : colors.space75,
        }
      : {
          color: disabled ? colors.space75 : colors.space,
        }),
  },

  error: {
    paddingTop: 1,
    fontDefaultSemiBold: 12,
    color: colors.alerts,
    maxWidth: '100%',
    margin: 0,
    ...(variant === 'borderless' && {
      marginTop: 2,
      paddingLeft: 0,
    }),
  },

  charCounter: {
    alignItems: 'flex-end',
    fontDefaultSemiBold: 12,
    color: colors.space60,
    marginTop: 1,
  },
});

export default styles;
